'use client';

import { faro } from '@grafana/faro-web-sdk';
import { useEffect } from 'react';

/**
 * Report a caught error to Faro RUM from a Next.js error boundary (`error.tsx`
 * / `global-error.tsx`).
 *
 * Next's segment `error.tsx` boundaries catch render errors and render fallback
 * UI WITHOUT re-throwing, so the error never bubbles to the root
 * `<FaroErrorBoundary>` and never triggers `window.onerror` — with console
 * capture disabled, the primary React error signal would otherwise be dark.
 * Calling this hook makes each boundary report explicitly.
 *
 * `faro` is safely optional-chained: when RUM is not initialized (no collector
 * URL) `faro.api` is a noop and this is a harmless call.
 */
export function useReportError(error: Error & { digest?: string }): void {
  useEffect(() => {
    faro?.api?.pushError?.(error);
  }, [error]);
}
